import { render, staticRenderFns } from "./Transportacion.vue?vue&type=template&id=641602fd&"
import script from "./Transportacion.vue?vue&type=script&lang=js&"
export * from "./Transportacion.vue?vue&type=script&lang=js&"
import style0 from "./Transportacion.vue?vue&type=style&index=0&id=641602fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports